module.exports = __webpack_public_path__ + "static/media/WalterDev.ef10fb86.pdf";